import PropTypes from 'prop-types'
import React, { Component } from 'react'

import './ToggleHorizontal.scss'

/**
 * ToggleHorizontal component
 * @param {Boolean} action - for toggle-horizontal
 * @return {Component} Component - ToggleHorizontal
 */
class ToggleHorizontal extends Component {
  static propTypes = {
    /** Function which call after toggle-horizontal */
    toggleCb: PropTypes.func.isRequired,

    /** Initial toggle-horizontal state */
    initial: PropTypes.bool,

    /** Disable toggle-horizontal */
    isDisabled: PropTypes.bool,
  }

  static defaultProps = {
    initial: false,
    isDisabled: false,
  }

  state = {
    active: this.props.initial,
  }

  setActiveState = action => {
    const { isDisabled, toggleCb } = this.props
    const { active } = this.state
    const biomeType = action ? 'subscription' : 'kits'

    if (isDisabled || active === action) {
      return false
    }
    this.setState({ active: action }, () => toggleCb(biomeType))

    return true
  }

  render() {
    const { isDisabled } = this.props
    const { active } = this.state
    const trueClassName = active ? 'active' : ''
    let classes = active ? 'toggle-horizontal--active ' : ''

    classes += isDisabled ? 'toggle-horizontal--disabled' : ''

    return (
      <div className={`toggle-horizontal ${classes}`}>
        <label className={`toggle-horizontal__body ${trueClassName}`}>
          <input
            className="toggle-horizontal__checkbox"
            type="checkbox"
            disabled={isDisabled}
            onClick={() => this.setActiveState(!active)}
          />
        </label>
      </div>
    )
  }
}

export default ToggleHorizontal
